<div class="carrossel-janela" #janela tabindex="0" role="region" aria-roledescription="carrossel"
     (keydown.arrowleft)="anterior()" (keydown.arrowright)="proximo()" (dragstart)="$event.preventDefault()">
  <div class="carrossel-trilho" [style.gap.px]="espaco()" [style.transform]="transformacao()">
    @for (item of itens(); track $index) {
      <div class="carrossel-item" [attr.aria-hidden]="$index !== indice()">
        <ng-container *ngTemplateOutlet="modelo(); context: { $implicit: item, indice: $index }"></ng-container>
      </div>
    }
  </div>
</div>
@if (mostrarIndicadores()) {
  <app-indicador-paginas [total]="itens().length" [posicao]="posicao()" [rotulo]="rotuloIndicador()" (selecionar)="irPara($event)"></app-indicador-paginas>
}
